import { AppModule } from 'app/module';
import { WatchlistButton } from 'module/watchlistButton/main';
import Template from './template.hbs';
import './styles.scss';

export class EbJobCard extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            watchlist: '.m-ebJobCard__mark .m-watchlistButton',
            spot: '.m-spot',
        };
    }

    getPropsFromDom() {
        return {
            id: this.dom.el.getAttribute('data-id'),
        };
    }

    subsProps() {
        if (this.watchlistButton) {
            this.watchlistButton.updateProps({ id: this.props.id });
        }
    }

    subs() {
        this.watchlistButton = this.dom.watchlist ? new WatchlistButton(this.dom.watchlist) : null;
    }
}
